export const state = () => ({
  page: 1,
  data: [],
  filters: '',
  headers: [
    { text: 'Driver', value: 'driver_name', sortable: false },
    { text: 'PCO', value: 'pco_number', sortable: false },
    { text: 'Branch', value: 'branch_name', sortable: false },
    { text: 'Started At', value: 'started_at', sortable: false },
  ],
  sortBy: undefined,
  sortDesc: undefined,
  totalResults: undefined,
  itemsPerPage: undefined,
});

export const getters = {
  getData(store) {
    return store.data;
  },
  getPage(store) {
    return store.page;
  },
  getHeaders(state) {
    return state.headers;
  },
  getTotalResults(state) {
    return state.totalResults;
  },
  getItemsPerPage(state) {
    return state.itemsPerPage;
  },
};

export const mutations = {
  setData(store, payload) {
    store.data = payload;
  },
  setPage(store, payload) {
    store.page = payload;
  },
  setFilters(store, payload) {
    store.filters = payload;
  },
  setTotalResults(state, value) {
    state.totalResults = value;
  },
  setSortBy(state, value) {
    state.sortBy = value;
  },
  setSortDesc(state, value) {
    state.sortDesc = value;
  },
  setItemsPerPage(state, value) {
    state.itemsPerPage = value;
  },
};

export const actions = {
  clearData({ commit }) {
    commit('clearData');
  },
  setPage({ commit }, payload) {
    commit('setPage', payload);
  },
  setFilters({ commit }, payload) {
    commit('setFilters', payload);
  },
  setSortBy({ commit }, value) {
    commit('setSortBy', value);
  },
  setSortDesc({ commit }, value) {
    commit('setSortDesc', value);
  },
  setItemsPerPage({ commit }, value) {
    commit('setItemsPerPage', value);
  },
  async loadPage({ commit, state }) {
    let url = '/v2/application/assessment';
    url += `?page=${state.page - 1}`;

    if (state.filters) url += state.filters;
    if (state.sortBy) url += `&order_by=${state.sortBy}`;
    if (state.sortDesc !== undefined) url += `&order=${state.sortDesc ? 'descending' : 'ascending'}`;
    if (state.itemsPerPage !== undefined) url += `&results=${state.itemsPerPage}`;

    const data = await this.$axios.$get(url);

    commit('setData', data.data);
    commit('setTotalResults', data.total);
  },
};
